/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_MediaInputs */

const en_quicktools_tab_media = /** @type {(inputs: Quicktools_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const fr_quicktools_tab_media = /** @type {(inputs: Quicktools_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Médias`)
};

const de_quicktools_tab_media = /** @type {(inputs: Quicktools_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien`)
};

const it_quicktools_tab_media = /** @type {(inputs: Quicktools_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

const ru_quicktools_tab_media = /** @type {(inputs: Quicktools_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СМИ`)
};

const es_quicktools_tab_media = /** @type {(inputs: Quicktools_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medios de comunicación`)
};

const zh_cn2_quicktools_tab_media = /** @type {(inputs: Quicktools_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`媒体`)
};

const ja_quicktools_tab_media = /** @type {(inputs: Quicktools_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディア`)
};

const hi_quicktools_tab_media = /** @type {(inputs: Quicktools_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिडिया`)
};

const pt_pt2_quicktools_tab_media = /** @type {(inputs: Quicktools_Tab_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mídia`)
};

/**
* | output |
* | --- |
* | "Media" |
*
* @param {Quicktools_Tab_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_media = /** @type {((inputs?: Quicktools_Tab_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_media(inputs)
	if (locale === "de") return de_quicktools_tab_media(inputs)
	if (locale === "it") return it_quicktools_tab_media(inputs)
	if (locale === "ru") return ru_quicktools_tab_media(inputs)
	if (locale === "es") return es_quicktools_tab_media(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_media(inputs)
	if (locale === "ja") return ja_quicktools_tab_media(inputs)
	if (locale === "hi") return hi_quicktools_tab_media(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_media(inputs)
	return en_quicktools_tab_media(inputs)
});